"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
var Baobab_Logger_1 = require("./Baobab-Logger");
var LoggerWithCache = (function (_super) {
    __extends(LoggerWithCache, _super);
    function LoggerWithCache() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoggerWithCache.prototype.getCacheKey = function (nodeInfo) {
        if (nodeInfo.key)
            return nodeInfo.key;
        var attrs = nodeInfo.attrs, name = nodeInfo.name;
        var result = name;
        if (attrs) {
            result += ':';
            for (var key in attrs) {
                result += "" + key + attrs[key];
            }
        }
        return result;
    };
    LoggerWithCache.prototype.createChildNode = function (nodeInfo, parent) {
        var e_1, _a;
        var cacheKey = this.getCacheKey(nodeInfo);
        var cachedNodes = parent.mapChildren[cacheKey];
        if (cachedNodes) {
            try {
                for (var cachedNodes_1 = __values(cachedNodes), cachedNodes_1_1 = cachedNodes_1.next(); !cachedNodes_1_1.done; cachedNodes_1_1 = cachedNodes_1.next()) {
                    var node_1 = cachedNodes_1_1.value;
                    if (node_1.flags.created)
                        continue;
                    node_1.flags.created = true;
                    return node_1;
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (cachedNodes_1_1 && !cachedNodes_1_1.done && (_a = cachedNodes_1.return)) _a.call(cachedNodes_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        var node = _super.prototype.createChildNode.call(this, nodeInfo, parent);
        if (cachedNodes) {
            cachedNodes.push(node);
        }
        else {
            parent.mapChildren[cacheKey] = [node];
        }
        return node;
    };
    return LoggerWithCache;
}(Baobab_Logger_1.Logger));
exports.LoggerWithCache = LoggerWithCache;
